
import MediaCard from '@/components/cards/MediaCard.vue'
import MediaCardRecent from '@/components/cards/MediaCardRecent.vue'

export default {
  name: 'MediaCarousel',
  components: {
    MediaCard,
    MediaCardRecent
  },
  props: {
    media: {
      type: Array,
      required: false
    },
    useRecentCard: {
      type: Boolean,
      required: false
    },
    useStateCollection: {
      type: Boolean,
      required: false
    },
    useStateSimilarMedia: {
      type: Boolean,
      required: false
    },
    useStateCastCredits: {
      type: Boolean,
      required: false
    },
    useStateCrewCredits: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    storeMedia() {
      return this.$store.state.media.media
    },
    scrollerItems() {
      if (this.media) return this.media
      if (!this.storeMedia) return []
      if (this.useStateCollection) {
        return this.storeMedia.collection.parts
      }
      if (this.useStateSimilarMedia) {
        return this.storeMedia.similarMedia
      }
      if (this.useStateCastCredits) {
        return this.storeMedia.castCredits
      }
      if (this.useStateCrewCredits) {
        return this.storeMedia.crewCredits
      }
      return []
    },
    minimumSize() {
      if (this.$vuetify.breakpoint.name === 'xs') return 155
      return 190
    },
    totalWidth() {
      if (this.scrollerItems) {
        return this.minimumSize * this.scrollerItems.length
      }
    }
  }
}
